import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import FieldError           from '../Fragments/FieldError';

let Quote = require('../Managers/Quote.js');
let Validation = require('../Managers/Validation.js');

class TextInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isHelpVisible: false,
            activeValue: props.defaultValue ? props.defaultValue : '',
        };
    }

    componentWillMount() {
        if (this.props.defaultValue) {
            this.setState({isValid: true});
            this.props.isValid(true);
        }
        if (window.uorn(this.props.dataValidation)) {
            this.setState({isValid: true});
            this.props.isValid(true);
        }
    }

    handleValidation(value) {
        // if we have a default value, we have to pass validation
        if (this.props.defaultValue) {
            this.setState({isValid: true});
            this.props.isValid(true);
        }

        // if they dont have validation data, we assume they're valid
        let isValid = true;

        // if we have validation rules, attempt to validate
        if (this.props.dataValidation) {
            let validation = Validation.validate(this.props.dataValidation, value, 'not_null')[0];
            isValid = validation.isValid;
            this.setState(validation);
        }

        // regardless of if we're valid or not, set the active value
        this.setState({
            activeValue: value,
        }, () => {
            this.props.isValid(isValid);
        });

        // regardless of validation, set the state
        Quote.set(this.props.storageKey, value, this.props.source);
        Quote.setAnswer(this.props.storageKey, value);

        // if we have a callback, call that
        if (this.props.callbackFunction) {
            this.props.callbackFunction(value);
        }
    }

    getCurrentValue() {
        return this.state.activeValue;
    }

    render() {
        return (
            <div className="question-input">
                <input
                    name={this.props.fieldName}
                    id={this.props.fieldName}
                    type="text"
                    maxLength={this.props.maxLength}
                    onBlur={(event) => { this.handleValidation(event.target.value); }}
                    defaultValue={this.props.defaultValue}
                />

                {this.state.hasError === true ?
                    <FieldError errors={this.state.errors} />
                :null}
            </div>
        );
    }
}

TextInput.propTypes = {
    fieldName:          PropTypes.string.isRequired,
    storageKey:         PropTypes.string,
    question:           PropTypes.string.isRequired,
    maxLength:          PropTypes.number.isRequired,
    callbackFunction:   PropTypes.func,
    defaultValue:       PropTypes.string,
    dataValidation:     PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    source:             PropTypes.string,
    isValid:            PropTypes.func,
};

export default TextInput;


// WEBPACK FOOTER //
// ./src/components/Fields/TextInput.js